import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { cellStyleClasses } from 'src/app/table-handling';

@Directive({
  selector: '[appCellStyles]',
  standalone: true,
})
export class CellStylesDirective implements OnChanges {
  private static readonly CELL_STYLES: string[] = Array.from(cellStyleClasses.values());

  @Input('appCellStyles') public cellStyles: string[] | null;

  constructor(private readonly element: ElementRef<HTMLElement>) {}

  public ngOnChanges({ cellStyles }: SimpleChanges): void {
    if (!cellStyles) {
      return;
    }

    this.element.nativeElement.classList.remove(...CellStylesDirective.CELL_STYLES);

    if (!this.cellStyles) {
      return;
    }

    this.element.nativeElement.classList.add(...this.cellStyles);
  }
}

